import { Badge } from '@chakra-ui/react'

const SOURCE_COLOR_SCHEME: Record<string, string> = {
  email: 'blue',
  atlas_app: 'purple',
  client_portal: 'green',
  voice_ai: 'teal',
  voice_call: 'cyan',
  endorsement: 'orange',
  web: 'gray',
  manual: 'gray',
  api: 'orange',
}

const SOURCE_FALLBACK_LABEL: Record<string, string> = {
  web: 'Client Portal (legacy)',
  manual: 'ATLAS App (legacy)',
  client_portal: 'Client Portal',
  atlas_app: 'ATLAS App (Internal Portal)',
  voice_ai: 'Voice — Alice',
  voice_call: 'Voice — Call',
  endorsement: 'Endorsement',
  email: 'Email',
}

function formatSource(value: string): string {
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

type Props = {
  source?: string | null
  label?: string | null
}

export function RequestSourceBadge({ source, label }: Props) {
  const normalized = (source ?? '').trim().toLowerCase()
  if (!normalized) return null

  const colorScheme = SOURCE_COLOR_SCHEME[normalized] ?? 'gray'
  const displayLabel =
    (label && label.trim()) || SOURCE_FALLBACK_LABEL[normalized] || formatSource(normalized)

  return (
    <Badge
      variant="outline"
      colorScheme={colorScheme}
      borderRadius="md"
      px={2.5}
      py={0.5}
      fontWeight="600"
      fontSize="xs"
      textTransform="none"
      whiteSpace="nowrap"
      title={displayLabel}
    >
      {displayLabel}
    </Badge>
  )
}
